import axios from 'axios'
import i18n from '../i18n.js'
import { attachUploadHandling } from './uploads.js'

/**
 * The client for pages used before anyone is signed in — signup, the invite form, the public TOR
 * upload. Same base URL and the same upload handling as the authenticated client; no Bearer
 * token, because there is nobody yet.
 *
 * It exists so those pages get the image shrinking and the progress reporting too. They are the
 * pages where a slow upload hurts most: somebody who has not got an account yet has nothing
 * saved and no reason to wait.
 */
const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8000',
})

publicApi.interceptors.request.use((config) => {
  try {
    const lng = i18n.resolvedLanguage || i18n.language
    if (lng) config.headers['Accept-Language'] = lng
  } catch { /* not resolved yet — the API answers in English */ }
  return config
})

attachUploadHandling(publicApi)

export default publicApi
